import { render, staticRenderFns } from "./addsurgical.vue?vue&type=template&id=73cbba20&scoped=true&"
import script from "./addsurgical.vue?vue&type=script&lang=js&"
export * from "./addsurgical.vue?vue&type=script&lang=js&"
import style0 from "./addsurgical.vue?vue&type=style&index=0&id=73cbba20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cbba20",
  null
  
)

export default component.exports